import { render, staticRenderFns } from "./AddBanks.vue?vue&type=template&id=10433a32&scoped=true&"
import script from "./AddBanks.vue?vue&type=script&lang=js&"
export * from "./AddBanks.vue?vue&type=script&lang=js&"
import style0 from "./AddBanks.vue?vue&type=style&index=0&id=10433a32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10433a32",
  null
  
)

export default component.exports